import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import API_BASE_URL from '../../../../Constants'
const RouteAnalysisFields = [
    { key: 'routeId', value: 'Route ID' },
    { key: 'mechanic', value: 'Mechanic' },
    { key: 'contacts', value: '# Contacts' },
    { key: "devices", value: 'Devices' },
    { key: 'maintenanceInvoiced', value: 'Maintenance Invoiced' },
    { key: 'maintenanceMaterials', value: 'Maintenance Materials' },
    { key: 'maintenanceHours', value: 'Maintenance Hours' },
    { key: "maintenanceLabor", value: 'Maintenance Labor' },
    { key: "maintenanceProfit", value: 'Maintenance Profit' },
    { key: "serviceInvoiced", value: 'Service Invoiced' },
    { key: "serviceMaterials", value: 'Service Materials' },
    { key: "serviceHoursBilled", value: 'Service Hours Billed' },
    { key: "serviceHoursNotBilled", value: 'Service Hours Not Billed' },
    { key: "serviceProfit", value: 'Service Profit' },
    { key: "proposalInvoiced", value: 'Proposal Invoiced' },
    { key: "proposalProfit", value: 'Proposal Profit' },
    { key: "unresolved", value: 'Unresolved' },
    { key: "unresolvedHours", value: 'Unresolved Hours' },
    { key: "totalProfit", value: 'Total Profit' },
    { key: "profitPerDevice", value: 'Profit / Device' },
    { key: "maintenancePercentage", value: "Maint %" },
    { key: "servicePercentage", value: 'Service %' },
    { key: "proposalPercentage", value: 'Proposal %' },
    { key: "profitPercentage", value: 'Profit Percentage' },
];

const OrderByFields = [
    { key: 'routeId', value: 'Route ID' },
    { key: 'mechanic', value: 'Mechanic' },
    { key: 'createdAt', value: 'Created At' },
];

const RouteAnalysis = () => {
    // Your component logic goes here
    const [routeAnalysis, setRouteAnalysis] = useState([]);
    const [sortedData, setSortedData] = useState([]);
    const [sortOrder, setSortOrder] = useState('asc'); // State to manage sort order
    const [orderBy, setOrderBy] = useState('routeID');

    useEffect(() => {
        const fetchRouteAnalysis = async () => {
            try {
                const response = await fetch( API_BASE_URL + '/api/maintenance/routeanalysis');
                if (!response.ok) {
                    throw new Error("Response Code Received: " + response.status);
                }
                const data = await response.json();
                console.log(data);
                setRouteAnalysis(data);
            } catch (error) {
                console.error("Network Error: ", error);
            }
        }

        fetchRouteAnalysis();
        // sortData();

        const intervalId = setInterval(fetchRouteAnalysis, 5000);
        return () => clearInterval(intervalId);
    }, []);


    useEffect(() => {
        const sortData = () => {

            const sortedData = [...routeAnalysis].sort((a, b) => {
                let valueA = a[orderBy];
                let valueB = b[orderBy];

                if (orderBy === 'createdAt') {
                    valueA = new Date(valueA);
                    valueB = new Date(valueB);
                }

                if (valueA < valueB) return sortOrder === 'asc' ? -1 : 1;
                if (valueA > valueB) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            });

            setSortedData(sortedData);

        };

        sortData();
    }, [orderBy, sortOrder, routeAnalysis]);

    //Export to .xlsx file and download functionality
    const exportData = (data, filename) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
    }


    return (
        <div className="mx-auto ml-4 h-screen w-full">
            <div className="flex justify-between items-center mb-4">
                <h2 className="mr-10 text-2xl font-bold">Route Analysis</h2>
                <label className="flex items-center">
                    <span className="mr-2">Filter By:</span>
                    <select
                        value={orderBy}
                        onChange={(e) => setOrderBy(e.target.value)}
                        className="px-4 mr-10 py-1 border rounded-md"
                    >
                        {OrderByFields.map((field) => (
                            <option value={field.key}>{field.value}</option>
                        ))}
                    </select>
                </label>
                <label className="flex items-center">
                    <button
                        type="export"
                        className="py-2 px-4 mr-10 bg-white font-bold text-sss-blue-sel hover:bg-sss-accent-yel rounded-md border-2 border-sss-blue-sel flex items-center"
                        onClick={() => exportData(routeAnalysis, 'RouteAnalysis.xlsx')}
                    >
                        Export Excel
                    </button>
                </label>
                <button
                    className="py-2 px-4 mr-10 bg-white font-bold text-sss-blue-sel hover:bg-sss-accent-yel rounded-md border-2 border-sss-blue-sel flex items-center"
                    onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                >
                    {sortOrder === 'asc' ? '⬆' : '⬇'}
                </button>
            </div>
            <div className="overflow-x-auto overflow-y-auto">
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {RouteAnalysisFields.map((field) => (
                                <th key={field.key} className="px-4 py-2 text-left font-semibold text-gray-600">
                                    {field.value}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {/* Sorted data is being used to filter that data based on 3 categories */}
                    <tbody className="text-gray-700">
                        {sortedData.map((route) => (
                            <tr key={route.routeId} className="border-t hover:bg-sss-accent-yel">
                                {RouteAnalysisFields.map((field) => (
                                    <td key={field.key} className="px-4 py-2">
                                        {route[field.key] !== undefined ? route[field.key] : 'N/A'}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        <tr className="border-t hover: bg-">
                            {RouteAnalysisFields.map((field) => (
                                field.key === 'routeID' ? (
                                    <td className="px-4 py-2 font-semibold">Total</td>
                                ) : (
                                    <td key={field.key} className="px-4 py-2"></td>
                                )
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RouteAnalysis;
